// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("../node_modules/.pnpm/@pmmmwh+react-refresh-webpack-plugin@0.6.3_@types+webpack@5.28.5_esbuild@0.28.2_webpack_ff73c8d345f95c30f85de11468cc592a/node_modules/@pmmmwh/react-refresh-webpack-plugin/client/ReactRefreshEntry.js");
let __webpack_exports__ = __webpack_require__("./src/index.tsx");
